module.exports = __webpack_public_path__ + "img/pr-3.b8c2717b.png";